import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import CalculadoraPro from "@/pages/CalculadoraPro";

export const Route = createFileRoute("/panel/calculadora-pro")({
  component: () => (
    <ProtectedRoute>
      <CalculadoraPro />
    </ProtectedRoute>
  ),
});
